import styled from '@emotion/styled';
import { colors } from '@anyroad/theme';

export const AdditionalInformationContainer = styled.div<{
  isLive?: boolean;
  borderless?: boolean;
}>`
  margin-bottom: 30px;

  ${(props) =>
    props.isLive &&
    `
    background-color: #f8f9fa;
    padding: 20px;
    border-radius: 8px;
  `}
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  gap: 12px;
`;

export const StepNumber = styled.span`
  color: ${colors.text.primary};
  border-radius: 50%;
  border: 1px solid ${colors.text.primary};
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
`;

export const SectionTitle = styled.h2`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: ${colors.text.primary};
  flex: 1;
`;

export const FormFieldsContainer = styled.div<{ borderless?: boolean }>`
  ${(props) =>
    !props.borderless &&
    `
    border-radius: 8px;
    padding: 20px;
    background-color: ${colors.white};
    margin-top: 16px;
  `}

  ${(props) =>
    props.borderless &&
    `
    margin-top: 16px;
  `}
`;

export const QuestionsContainer = styled.div<{ hasWaiver: boolean }>`
  ${(props) =>
    props.hasWaiver &&
    `
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid ${colors.border};
  `}
`;

export const WaiverContainer = styled.div`
  margin-top: 20px;
`;
